import React from "react";
import styles from "./StoreLinking.module.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button} from "../../../components/button/Button";
import addApp from "../../../assets/images/add-app.png";
import {Toast} from "../../../components/toast/Toast";
import {faGooglePlay} from "@fortawesome/free-brands-svg-icons";
import {useGoogleLogin} from "@react-oauth/google";

function StoreLinking({icon, onSubmit, onClose}) {
    const [toastMessage, setToastMessage] = React.useState("");
    const [storeId, setStoreId] = React.useState("");

    const scopes = [
        "https://www.googleapis.com/auth/userinfo.profile",
        "https://www.googleapis.com/auth/userinfo.email",
        "https://www.googleapis.com/auth/androidpublisher",
    ];

    const handlePlayStoreRegistration = useGoogleLogin({
        flow: "auth-code",
        scope: scopes.join(" "),
        onSuccess: (response) => registerPlayStore(response),
        onError: (errorResponse) => handleRegistrationError(errorResponse),
    });

    async function handleSubmit(e) {
        e.preventDefault();

        if (!storeId) {
            showToast("Please fill all fields");
            return;
        }

        handlePlayStoreRegistration();
    }

    async function registerPlayStore(codeResponse) {
        onSubmit({code: codeResponse?.code ?? '', store: 'play_store', storeId});
    }

    function handleRegistrationError(error) {
        console.log(error);
        // TODO: Handle error case
    }

    function showToast(message) {
        setToastMessage(message);
        setTimeout(() => setToastMessage(""), 2000);
    }

    return (
        <>
            <div className={styles.storeLinking}>
                <div className={styles.actionContainer}>
                    <form onSubmit={handleSubmit}>
                        <img src={icon || addApp} alt="App Icon"/>
                        <div>
                            <input
                                type="text"
                                id="package-name"
                                className="input"
                                value={storeId}
                                placeholder="Enter package name"
                                onChange={(e) => setStoreId(e.target.value)}
                            />
                        </div>
                        <div className={styles.actions}>
                            <Button
                                label="Cancel"
                                variant="primary"
                                onClick={onClose}
                            />
                            <Button
                                label="Create"
                                variant={"primary"}
                                type="submit"
                            />
                        </div>
                    </form>
                </div>
                <div className={styles.sideImage}>
                    <FontAwesomeIcon icon={faGooglePlay} size="2x"/>
                    <span>Register to Play Store</span>
                </div>
            </div>
            {toastMessage && <Toast message={toastMessage} onClose={() => setToastMessage("")}/>} 
        </>
    );
}

export {StoreLinking};
